module.exports = __webpack_public_path__ + "static/xiao-banner-93dd8d9ba6eded3f57771e01ad7e4f9a.png";